import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import { IFireDispatchDetails } from 'src/models/fire-fighting-dispatch.model';
import { IFireDispatch } from 'src/models/fire-dispatch.model';
import services from 'src/services/fire-dispatch.service';

export const actionTypes = {
  DEFAULT: 'DEFAULT',
  FIRE_DISPATCH_DETAILS_DATA: 'FIRE_DISPATCH_DETAILS_DATA',
} as const;

export const asyncActions = {
  getDefault: {
    type: actionTypes.DEFAULT,
    service: services.getFireDispatchDetailsData,
  },
  getFireDispatchDetailsData: {
    type: actionTypes.FIRE_DISPATCH_DETAILS_DATA,
    service: services.getFireDispatchDetailsData,
  },
};

export type IFireDispatchDetailsAsync = typeof asyncActions;

export interface IFireDispatchDetailsState
  extends ICommonState<IFireDispatchDetailsAsync> {
  fireDispatch?: IFireDispatchDetails;
  data?: IFireDispatch;
}

export const defaultState: IFireDispatchDetailsState = {
  status: {},
};

const FireDispatchDetailsReducer = (
  state: IFireDispatchDetailsState = defaultState,
  action: IReducerAction<IFireDispatchDetailsAsync>
): IFireDispatchDetailsState => {
  switch (action.type) {
    case actionTypes.FIRE_DISPATCH_DETAILS_DATA: {
      const dispatchData = action.payload?.fireDispatch?.rows[0] ?? undefined;
      return {
        ...state,
        fireDispatch: dispatchData,
        data: {
          ...dispatchData,
          dispatchDate: dispatchData?.dispatchDate?.toDateString(),
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default FireDispatchDetailsReducer;
